"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// all keys stored in the cache by this SDK will be prefixed with this value
// const CACHE_PREFIX = 'celebration-service:';

// cached for 1 minute
// const CACHE_DURATION_MIN = 1;

function SDK(baseUrl, fetch, cacheInterface, companyId) {
  var logger = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console;
  function _fetchJson(url) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, res, _res, data, text;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'content-type', 'application/json'));
      }
      // some of the sdks are used in the browswer where the native fetch is used.
      if (typeof window === 'undefined') {
        options.responseType = 'json';
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_4) {
          try {
            res = $await_4;
            return $return(res.body);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } else {
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_5) {
          try {
            _res = $await_5;
            if (_res.ok) {
              return Promise.resolve(_res.json()).then($return, $error);
            } else {
              if (_res.headers.get('Content-Type').indexOf('application/json') !== -1) {
                return Promise.resolve(_res.json()).then(function ($await_7) {
                  try {
                    data = $await_7;
                    logger.error({
                      status: _res.status,
                      data: data
                    }, 'unsuccessful request to celebration-service.');
                    return $error(_objectSpread({
                      status: _res.status
                    }, data));
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              }
              return Promise.resolve(_res.text()).then(function ($await_8) {
                try {
                  text = $await_8;
                  logger.error({
                    status: _res.status,
                    text: text
                  }, 'unsuccessful request to celebration-service.');
                  return $error(text);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }
            return $If_1.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_1() {
        return $return();
      }
      return $If_1.call(this);
    });
  }

  // const getKey = ( key ) => {
  //     if ( companyId ) {
  //         return `${ CACHE_PREFIX }${ companyId }:${ key }`;
  //     }
  //     return `${ CACHE_PREFIX }${ key }`;
  // };

  // const _cacheGet = ( key ) => cacheInterface.get( getKey( key ) );
  // const _cacheSet = ( key, value, ttl ) => cacheInterface.set( getKey( key ), value, ttl );
  // const _cacheRemove = ( key ) => cacheInterface.remove( getKey( key ) );
  // const _cacheClear = () => cacheInterface.clear();

  return {
    //////////////////////////////////////////////////
    // CELEBRATION TYPES
    //////////////////////////////////////////////////

    getTypes: function getTypes() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        return Promise.resolve(_fetchJson('/types', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'GET'
        }))).then($return, $error);
      });
    },
    getType: function getType(id) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson("/types/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'GET'
        }))).then($return, $error);
      });
    },
    searchTypes: function searchTypes() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var filters, fetchOptions;
        filters = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson('/types/search', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'POST',
          body: JSON.stringify(filters)
        }))).then($return, $error);
      });
    },
    createType: function createType(type) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson('/types', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'POST',
          body: JSON.stringify(type)
        }))).then($return, $error);
      });
    },
    updateType: function updateType(id, type) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
        return Promise.resolve(_fetchJson("/types/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'PUT',
          body: JSON.stringify(type)
        }))).then($return, $error);
      });
    },
    deleteType: function deleteType(id) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson("/types/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'DELETE'
        }))).then($return, $error);
      });
    },
    //////////////////////////////////////////////////
    // CELEBRATION CONFIGS
    //////////////////////////////////////////////////

    getConfigs: function getConfigs() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        return Promise.resolve(_fetchJson('/configs', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'GET'
        }))).then($return, $error);
      });
    },
    getConfig: function getConfig(id) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson("/configs/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'GET'
        }))).then($return, $error);
      });
    },
    createConfig: function createConfig(typeIds) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson('/configs', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'POST',
          body: JSON.stringify({
            typeIds: typeIds
          })
        }))).then($return, $error);
      });
    },
    updateConfig: function updateConfig(id, typeIds) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
        return Promise.resolve(_fetchJson("/configs/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'PUT',
          body: JSON.stringify({
            typeIds: typeIds
          })
        }))).then($return, $error);
      });
    },
    deleteConfig: function deleteConfig(id) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson("/configs/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'DELETE'
        }))).then($return, $error);
      });
    },
    //////////////////////////////////////////////////
    // CELEBRATIONS
    //////////////////////////////////////////////////

    getCelebration: function getCelebration(id) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson("/celebrations/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'GET'
        }))).then($return, $error);
      });
    },
    createCelebration: function createCelebration(celebration) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson('/celebrations', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'POST',
          body: JSON.stringify(celebration)
        }))).then($return, $error);
      });
    },
    updateCelebration: function updateCelebration(id, celebration) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
        return Promise.resolve(_fetchJson("/celebrations/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'PUT',
          body: JSON.stringify(celebration)
        }))).then($return, $error);
      });
    },
    deleteCelebration: function deleteCelebration(id) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson("/celebrations/".concat(encodeURIComponent(id)), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'DELETE'
        }))).then($return, $error);
      });
    },
    searchCelebrations: function searchCelebrations(filters) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson('/celebrations/search', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'POST',
          body: JSON.stringify(filters)
        }))).then($return, $error);
      });
    },
    //////////////////////////////////////////////////
    // PREFERENCES
    //////////////////////////////////////////////////

    getMyPreferences: function getMyPreferences() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        return Promise.resolve(_fetchJson('/preferences', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'GET'
        }))).then($return, $error);
      });
    },
    saveMyPreferences: function saveMyPreferences(preferences) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        return Promise.resolve(_fetchJson('/preferences', _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'POST',
          body: JSON.stringify(preferences)
        }))).then($return, $error);
      });
    },
    getUserPreferences: function getUserPreferences(rosterPersonId) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var skipEligibility, fetchOptions, query;
        skipEligibility = $args.length > 1 && $args[1] !== undefined ? $args[1] : false;
        fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
        query = skipEligibility === true ? '?skipEligibility=true' : null;
        return Promise.resolve(_fetchJson("/preferences/".concat(encodeURIComponent(rosterPersonId)).concat(query ? query : ''), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'GET'
        }))).then($return, $error);
      });
    },
    //////////////////////////////////////////////////
    // RECIPIENTS
    //////////////////////////////////////////////////

    saveRecipientThankYou: function saveRecipientThankYou(recipientId, thanksMessageId) {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var fetchOptions;
        fetchOptions = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
        return Promise.resolve(_fetchJson("/recipients/".concat(encodeURIComponent(recipientId), "/thank-you"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
          method: 'PUT',
          body: JSON.stringify({
            thanksMessageId: thanksMessageId
          })
        }))).then($return, $error);
      });
    }
  };
}
var noCache = {
  get: function get() {
    return undefined;
  },
  set: function set(key, value, lifetimeMins) {
    return value;
  },
  remove: function remove(key) {
    return undefined;
  },
  clear: function clear() {
    return undefined;
  }
};
module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  var companyId = arguments.length > 3 ? arguments[3] : undefined;
  var logger = arguments.length > 4 ? arguments[4] : undefined;
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }
  return new SDK(url, customFetch, cacheInterface, companyId, logger);
};
//# sourceMappingURL=index.js.map